import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BaseLink from '~/components/base/BaseLink';
import Image from '~/components/base/Image';

import { transition } from '~/styles/transition';
import { formatText, dynamicFontSize } from '~/utilities/helpers';
import { h3, medium } from '~/styles/typography';

const FeaturedImage = styled(Image)`
    ${transition({ speed: 500, easingFunction: 'ease-in-out' }, 'box-shadow')};
    border-radius: 18px;
    box-shadow: none;
`;

const Title = styled.h3`
    ${transition({ speed: 500, easingFunction: 'ease-in-out' }, 'color')};
    ${h3};
    font-size: ${dynamicFontSize(2.2, 3.4, 3.8)};
    margin-top: 25px;
`;

const Excerpt = styled.div`
    ${medium};
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    margin-top: 10px;
`;

const LinkWrapper = styled(BaseLink)`
    &:hover,
    &:focus {
        ${FeaturedImage} {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
        }

        ${Title} {
            color: ${({ theme }) => theme.colors.primary.yellow};
        }
    }
`;

const ArticleCard = ({ title, excerpt = '', featuredImage = {}, uri }) => (
    <LinkWrapper to={uri}>
        <article>
            {featuredImage?.node ? (
                <FeaturedImage {...featuredImage.node} />
            ) : null}
            <Title>{formatText(title)}</Title>
            {excerpt ? <Excerpt>{formatText(excerpt)}</Excerpt> : null}
        </article>
    </LinkWrapper>
);

ArticleCard.propTypes = {
    title: PropTypes.string.isRequired,
    excerpt: PropTypes.string,
    featuredImage: PropTypes.shape({}),
    uri: PropTypes.string.isRequired
};

export default ArticleCard;
